import { Link } from "react-router-dom";
import { categories, articles } from "@/mocks/mangaData";

export default function CategoryStrip() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6" aria-labelledby="category-heading">
      <div className="flex flex-col items-start justify-between gap-3 sm:flex-row sm:items-end">
        <div>
          <h2 id="category-heading" className="font-heading text-2xl text-foreground-950 md:text-3xl">
            追更分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">按你的喜好，快速找到想追的日漫。</p>
        </div>
        <Link
          to="/about"
          className="inline-flex whitespace-nowrap items-center gap-1 text-sm text-primary-600 transition-colors hover:text-primary-700"
        >
          查看全部 <i className="ri-arrow-right-line" />
        </Link>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {categories.map((cat) => {
          const count = articles.filter((a) => a.categoryId === cat.id).length;
          return (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                <i className={`${cat.icon} text-2xl`} />
              </span>
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="text-base font-semibold text-foreground-950">{cat.name}</h3>
                  <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">{count} 篇</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{cat.description}</p>
                <span className="mt-2 inline-flex items-center gap-1 text-sm font-medium text-primary-600 opacity-0 transition-opacity group-hover:opacity-100">
                  去看看 <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}